import React, { createContext, useContext, useEffect, useState } from 'react';
import { getCompanyRegistry } from '../lib/company/companyRegistrySingleton';

const SalonTzContext = createContext<string>('UTC');

export const SalonTzProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [timezone, setTimezone] = useState<string>('UTC');

  useEffect(() => {
    const settings = getCompanyRegistry().getSettings();
    if (settings && settings.timezone_name) {
      setTimezone(settings.timezone_name);
    }
  }, []);

  return (
    <SalonTzContext.Provider value={timezone}>
      {children}
    </SalonTzContext.Provider>
  );
};

/**
 * Hook to access the salon's timezone.
 * @returns The IANA timezone name or 'UTC' if not set.
 */
export function useSalonTz(): string {
  return useContext(SalonTzContext);
}
